import styled from 'styled-components'

import ButtonGroup from '../ButtonGroup'

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: 'center';

  & > *:not(:first-child) {
    margin-left: 8px;
  }
`

const RowActionWrapper = ({ groupButtons, children }) => {
  return (
    <Wrapper className={groupButtons ? 'groupButtons' : ''}>
      {groupButtons ? <ButtonGroup>{children}</ButtonGroup> : children}
    </Wrapper>
  )
}

RowActionWrapper.defaultProps = {
  groupButtons: true,
}

RowActionWrapper.displayName = 'RowActionWrapper'
export default RowActionWrapper
